import React from 'react';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-yellow-500">ARCHIFAB</h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Premium architecture and interior design solutions crafted with creativity, expertise, and trust since 1992.
            </p>
            <div className="flex items-center gap-2 text-gray-400">
              <Globe size={16} />
              <a href="http://www.archifab.in" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-500 transition-colors">
                www.archifab.in
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('#home')}
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#about')}
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#services')}
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#projects')}
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Projects
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#team')}
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Team
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Architecture</li>
              <li>Interior Design</li>
              <li>Engineering</li>
              <li>Planning Services</li>
              <li>Turnkey Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-gray-400">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span className="text-sm">Chennai: Mogappair West, Chennai 600037</span>
              </div>
              <div className="flex items-start gap-2 text-gray-400">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span className="text-sm">Bengaluru: HSR Layout, Bengaluru-102</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400">
                <Phone size={18} />
                <a href="tel:+916379541008" className="hover:text-yellow-500 transition-colors">
                  +91 63795 41008
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-400">
                <Mail size={18} />
                <a href="mailto:info@archifab.in" className="hover:text-yellow-500 transition-colors">
                  info@archifab.in
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex justify-center items-center">
            <p className="text-gray-400 text-sm">
              Designed with <span className="text-yellow-500">♥</span> by ARCHIFAB Team
            </p>
          </div>
        </div>
      </div>

      {/* Work With Us CTA */}
      <div className="bg-yellow-600 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <h3 className="text-2xl font-bold text-white mb-1">Ready to Start Your Project?</h3>
              <p className="text-yellow-100">Let's create something extraordinary together</p>
            </div>
            <button
              onClick={() => scrollToSection('#contact')}
              className="px-8 py-3 bg-black text-white font-semibold rounded-sm hover:bg-gray-900 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Work With Us
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;